module.exports = __webpack_public_path__ + "img/18.f27e7a86.png";